import { ChangeEventHandler } from 'react';

type Props = {
  name?: string;
  label: string;
  value: string | number;
  isChecked: boolean;
  onChangeHandler?: ChangeEventHandler<HTMLInputElement>;
}

export const InputRadio = ({
  name,
  label,
  value,
  isChecked,
  onChangeHandler
}: Props) => {
  return (
    <label data-testid="input-radio" className="input-control input-control__radio">
      <input
        id={`radio-${value}`}
        data-testid={`radio-${value}`}
        type="radio"
        name={name}
        value={value}
        checked={isChecked}
        onChange={onChangeHandler}
      />
      <span>{label}</span>
    </label>
  );
}
